const list = {
  // =================================================================================================================
  components() {
    return [
      // ===========[ 날짜 관련 ]==========
      {
        component: "search-year",
        label: "평가연도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          gridTemplateColumns: "80px 178px",
          xlWidthFull: true,
        },
      },
      {
        component: "search-start-end",
        label: "평가일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
          gridTemplateColumns: "80px 1fr",
        },
      },
      {
        component: "search-check-group",
        label: "중요위험",
        value: "importantRisk",
        query: { ck_l: "checkList" },
        options: {
          list: [
            { text: "Y", value: "Y" },
            { text: "N", value: "N" },
          ],
          selectMaxCount: 2,
          default: [],
          gridTemplateColumns: "80px 178px",
        },
      },
      { component: "empty-space" },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
          gridTemplateColumns: "80px 1fr",
        },
      },
      {
        component: "search-start-end",
        label: "결재완료일",
        value: "approvalDate",
        query: { as: "startDate", ae: "endDate" },
        options: {
          default: { sd: "", ed: "" },
          gridTemplateColumns: "80px 1fr",
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: {
          hiddenList: ["사업장명", "중요위험", "평가일", "구분1", "구분2", "구분3", "사업장명", "팀(업체)명", "공장명", "대분류", "중분류", "소분류"],
          gridTemplateColumns: "80px 1fr",
        },
      },
      { component: "empty-space" },
      {
        component: "search-select",
        label: "구분1",
        value: "t1",
        query: {"t1": "select"},
        options: {
          gridTemplateColumns: "80px 1fr",
          default: "",
          items: [
            { text: "전체", value: "" },
            { text: "정기", value: "정기" },
            { text: "수시", value: "수시" }
          ]
        }
      },
      {
        component: "search-select",
        label: "구분2",
        value: "t2",
        query: {"t2": "select"},
        options: {
          gridTemplateColumns: "80px 1fr",
          default: "",
          items: [
            { text: "전체", value: "" },
            { text: "JSA", value: "JSA" },
            { text: "DKRAS", value: "DKRAS" },
            { text: "DKRAS+JSA", value: "DKRAS+JSA" }
          ]
        }
      },
      { component: "empty-space" },
      {
        component: "search-classification",
        label: "",
        value: "classification",
        query: {
          cf_team: "팀업체명",
          cf_factory: "공장명",
          cf_large: "대분류",
          cf_medium: "중분류",
          cf_small: "소분류"
        },
        options: {
          gridTemplateColumns: "80px 1fr",
          searchFieldKey: "field",
          boardIds: [814],
          classificationBoardId: 895, // 공정분류표(수급업체)
        },
      },
    ];
  },
  validate: (nav) => {
    const search = nav.value;
    const start = search.date.startDate || `${search.year}-01-01`;
    const end = search.date.endDate
      ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd")
      : `${parseInt(search.year) + 1}-01-01`;
    if (start >= end) {
      const endDisplay = search.date.endDate || `${parseInt(search.year)}-12-31`;
      return `평가일 검색 범위가 올바르지 않습니다.<br>시작일: ${start}<br>종료일: ${endDisplay}`;
    }
    return null;
  },

  // 895(공정분류표) 조건으로 매칭되는 게시글 id 목록을 조회한다.
  // 895 이름(대/중/소분류)은 나중에 바뀔 수 있으므로, 이름이 아니라 814에 저장된 raw.id 로 매칭해야
  // 895가 개정(리네임)되어도 검색이 정확하게 유지된다.
  _load895Ids: async (vue, projectId, conditions895) => {
    if (!conditions895 || conditions895.length === 0) return null;

    const response = await vue.$store.dispatch("board/LOAD_POST_LIST", {
      boardId: 895,
      projectId,
      page: 1,
      perPage: 1000,
      conditions: conditions895,
    });

    return response && response.data ? response.data.map((post) => post.id) : [];
  },

  // ids 가 비어있으면 반드시 결과가 없도록, 그렇지 않으면 raw.id IN 조건을 추가한다.
  _pushRawIdCondition: (conditions, ids) => {
    if (ids === null) return; // 검색 조건 자체가 없었던 경우 (전체 조회 유지)
    if (ids.length === 0) {
      conditions.push({ key: "body.공정분류.raw.id", operator: "=", value: -1 });
    } else {
      conditions.push({ key: "body.공정분류.raw.id", operator: "IN", value: ids });
    }
  },

  getConditions: async (nav, vue) => {
    const conditions = [];
    const search = nav.value;
    const projectId = nav.projectId;

    // 구분1
    if (search.t1 && search.t1 !== "전체") {
      conditions.push({ key: "body.공정분류.구분", operator: "=", value: search.t1 });
    }

    // 구분2
    if (search.t2 && search.t2 !== "전체") {
      conditions.push({ key: "body.위험성평가구분", operator: "=", value: search.t2 });
    }

    //  검색일
    if (search.date.startDate) {
      conditions.push({ key: "body.위험성평가정보.평가일자", operator: ">=", value: search.date.startDate });
    } else {
      conditions.push({ key: "body.위험성평가정보.평가일자", operator: ">=", value: `${search.year}-01-01` });
    }

    if (search.date.endDate) {
      conditions.push({ key: "body.위험성평가정보.평가일자", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    } else {
      conditions.push({ key: "body.위험성평가정보.평가일자", operator: "<", value: `${parseInt(search.year) + 1}-01-01` });
    }

    // 결재완료일
    if (search.approvalDate.startDate) {
      conditions.push({ key: "updated_at", operator: ">=", value: search.approvalDate.startDate });
    }

    if (search.approvalDate.endDate) {
      conditions.push({ key: "updated_at", operator: "<", value: search.approvalDate.endDate ? new Date(search.approvalDate.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    // 중요위험
    if (search.importantRisk && search.importantRisk.length > 0) {
      conditions.push({ key: "body.위험성평가표.중요위험", operator: "IN", value: search.importantRisk });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      let key = search.column.head;
      if (key === '팀(업체)명') {
        key = '팀명';
      }

      if (key === '공동작성유무') {
        conditions.push({ key: "body.공동작성.공동작성여부", operator: "LIKE", value: `%${search.column.keyword}%` });
      } else if (key === '구분3') {
        conditions.push({ key: "body.위험성평가구분", operator: "LIKE", value: `%${search.column.keyword}%` });
      } else {
        conditions.push({key: types[key], operator: "LIKE", value: `%${search.column.keyword}%`});
      }
    }

    // 대분류/중분류/소분류 (815/page 검색에서 사용됨)
    // 895에서 현재 조건에 맞는 게시글을 먼저 찾고, 그 id들로 814의 raw.id를 매칭한다.
    if (search.대분류 || search.중분류 || search.소분류) {
      const conditions895 = [];
      if (search.대분류) conditions895.push({ key: "body.대분류", operator: "LIKE", value: `%${search.대분류}%` });
      if (search.중분류) conditions895.push({ key: "body.중분류", operator: "LIKE", value: `%${search.중분류}%` });
      if (search.소분류) conditions895.push({ key: "body.소분류", operator: "LIKE", value: `%${search.소분류}%` });

      const ids = await list._load895Ids(vue, projectId, conditions895);
      list._pushRawIdCondition(conditions, ids);
    }

    // classification 검색 조건
    // 업체/공장명/대·중·소분류는 모두 895(공정분류표)가 원본이고 814에는 작성 시점 스냅샷만 남는다.
    // 상세 화면(Write.vue > syncProcess895Data)은 895 최신값으로 덮어써서 보여주므로,
    // 검색도 814 저장값이 아니라 895 최신값 기준으로 맞춰야 목록/상세가 어긋나지 않는다.
    if (search.classification) {
      const conditions895 = [];
      if (search.classification.팀업체명 && search.classification.팀업체명 !== "전체") {
        conditions895.push({ key: "body.업체명", operator: "=", value: search.classification.팀업체명 });
      }
      if (search.classification.공장명 && search.classification.공장명 !== "전체") {
        conditions895.push({ key: "body.공장명", operator: "=", value: search.classification.공장명 });
      }
      if (search.classification.대분류 && search.classification.대분류 !== "전체") {
        conditions895.push({ key: "body.대분류", operator: "=", value: search.classification.대분류 });
      }
      if (search.classification.중분류 && search.classification.중분류 !== "전체") {
        conditions895.push({ key: "body.중분류", operator: "=", value: search.classification.중분류 });
      }
      if (search.classification.소분류 && search.classification.소분류 !== "전체") {
        conditions895.push({ key: "body.소분류", operator: "=", value: search.classification.소분류 });
      }

      if (conditions895.length > 0) {
        const ids = await list._load895Ids(vue, projectId, conditions895);
        list._pushRawIdCondition(conditions, ids);
      }
    }

    return conditions;
  },

  // 목록에 표시되는 소분류(등)는 814 문서 저장 시점의 895 스냅샷(raw)이라 895가 리네임되면 옛 이름으로 남는다.
  // 목록을 불러온 뒤, raw.id로 895 최신 데이터를 일괄 조회해서 각 행에 latest895으로 붙여준다.
  prefixFunc: async (vue, response, options) => {
    const newResponse = { ...response };

    try {
      const rawIdByPostId = {};
      const rawIds = [];

      for (const item of newResponse.data || []) {
        const content = JSON.parse(item.post_content);
        const rawId = content && content.body && content.body.공정분류 && content.body.공정분류.raw && content.body.공정분류.raw.id;
        if (rawId) {
          rawIdByPostId[item.id] = rawId;
          if (!rawIds.includes(rawId)) rawIds.push(rawId);
        }
      }

      if (rawIds.length > 0) {
        // 엑셀 다운로드처럼 행이 많을 때 한 번에 수천 개를 조회하지 않도록 나눠서 요청한다.
        const CHUNK_SIZE = 100;
        const latestById = {};

        for (let i = 0; i < rawIds.length; i += CHUNK_SIZE) {
          const chunk = rawIds.slice(i, i + CHUNK_SIZE);
          const res895 = await vue.$store.dispatch("board/LOAD_POST_LIST", {
            boardId: 895,
            projectId: options.projectId,
            page: 1,
            perPage: chunk.length,
            postIds: chunk,
          });

          for (const post of (res895 && res895.data) || []) {
            latestById[post.id] = JSON.parse(post.post_content).body;
          }
        }

        newResponse.data = newResponse.data.map((item) => ({
          ...item,
          latest895: latestById[rawIdByPostId[item.id]] || null,
        }));
      }
    } catch (e) {
      // 895 최신 데이터 조회 실패 시 기존 저장값(raw) 그대로 표시
    }

    return newResponse;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "구분1",
        key: "body.공정분류.구분",
      },
      {
        name: "구분2",
        key: "body.위험성평가구분",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "팀(업체)명",
        key: "body.위험성평가정보.팀",
      },
      {
        name: "공장명",
        key: "body.공정분류.raw.공장명",
      },
      {
        name: "대분류",
        key: "body.공정분류.raw.대분류",
      },
      {
        name: "중분류",
        key: "body.공정분류.raw.중분류",
      },
      {
        name: "소분류",
        key: "body.공정분류.raw.소분류",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "중요위험",
        key: "body.위험성평가표.중요위험",
      },
      {
        name: "평가일",
        key: "body.위험성평가정보.평가일자",
      },
      {
        name: "아차사고",
        key: "body.공정분류.아차사고",
      },
      {
        name: "아차사고 내용",
        key: "",
      },
      {
        name: "결재완료일",
        key: "updated_at",
      },
    ];
  },

  getCol: (index, value, func) => {
    try {
      // 업체명/공장명/대·중·소분류는 814 저장 시점의 895 스냅샷(raw)이라 895가 개정되면 옛 이름으로 남는다.
      // 상세 화면은 895 최신값으로 덮어써서 보여주므로, 목록도 prefixFunc이 붙여준 latest895를 우선 사용한다.
      // (latest895 조회 실패 시에는 저장된 raw 값으로 폴백)
      if (value.latest895) {
        const 최신값 = {
          3: value.latest895.업체명,
          4: value.latest895.공장명,
          5: value.latest895.대분류,
          6: value.latest895.중분류,
          7: value.latest895.소분류,
        }[index];
        if (최신값) return 최신값;
      }

      if (func._getCol) {
        if (index === 12) {
          const 위험성평가구분 = func.getContent(value).위험성평가구분;
          if (위험성평가구분 === "DKRAS") {
            const 아차사고 = func.getContent(value).아차사고_개정;
            return 아차사고.length > 0 ? 아차사고.map((e) => e.내용).join(", ") : "";
          } else {
            const 아차사고 = func.getContent(value).아차사고;
            return 아차사고.length > 0 ? 아차사고.map((e) => e.내용).join(", ") : "";
          }
        } else if (index === 13) {
          // 결재승인 상태일 때에만 시간을 표시해야 한다
          if (value.document_status.code === 'approved') {
            return (value.post && value.post.updated_at) ? new Date(value.post.updated_at).format("yyyy-MM-dd") : "";
          } else {
            return "-";
          }
        } else {
          const data = func._getCol(index, value, func);
          return data;
        }
      }
    } catch (e) {
      //
    }
    return "";
  },

  getSearchKeyValue: (/* nav */) => {},
  getSearchKeyword: (/* nav */) => {},
};

export default list;
